var Panel                   = require("../Panel");
var $                       = require("jquery");
var template                = require("./bar.ejs");
var search_item             = require("./search_item.ejs");
var cadastre_search_item    = require('./cadastre_search_item.ejs');

var SearchBarExt = Panel.extend({

    initialize: function(options){
        var that = this;
        that.searchResults = [];

        that.marker = new ol.style.Icon({
            src: 'data:image/svg+xml;base64,PHN2ZyBpZD0ibWFya2VyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4gIDxjaXJjbGUgZmlsbD0iI2YwNWEzYyIgb3BhY2l0eT0iMC4yIiBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiLz4gIDxjaXJjbGUgZmlsbD0iI2YwNWEzYyIgc3Ryb2tlLXdpZHRoPSIycHgiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZT0iI2ZmZiIgY3g9IjEyIiBjeT0iMTIiIHI9IjUiLz48L3N2Zz4=',
            anchor: [0.5, 0.5],
            imgSize: [24, 24] // imgSize необходим для корректной работы в IE
        });

        if (!("layer" in options) && !("url" in options)) {
            throw new Error("Не переданы слой или url");
        } else if (!(options.layer instanceof omjs.ol.layer.Vector)) {
            throw new Error("Слой должен быть векторный");
        }

        SearchBarExt.__super__.initialize.call(that, options);

        that.setOptions(options);
        that.layer = that.options.layer;
        that.map = that.options.map;

        that.layer.setStyle(new ol.style.Style({
            fill : new ol.style.Fill({
                color: 'rgba(255,0,0,0.4)'
            }),
            image: new ol.style.Circle({
                fill  : new ol.style.Fill({
                    color: 'rgba(255,0,0,0.4)'
                }),
                stroke: new ol.style.Stroke({
                    color: 'rgba(0,0,0,0.7)',
                    width: 2
                }),
                radius: 10
            })
        }));

        that.container = that.getContainer();
        that.container.html( $(template({
            objectsTab: that.translate('Объекты'),
            addressTab: that.translate('Адрес'),
            cadastreTab: that.translate('ПКК')
        })) );
        that.container.attr("tabindex", "-1");

        if (
            !that.options.pkk_settings
            || !that.options.pkk_settings.pkk_search_enabled
        ) {
            var cadastre_tab = that.container.find('li[data-tab="cadastre"]');
            cadastre_tab.remove();
        }

        // Получим настройки поиска из публикации
        that.searchSettings = options.search.values;
        that._searchInputWrapper = that.container.find("._search-bar-input-wrapper");
        that._searchInput = that.container.find("input[name=search-bar]");
        that._searchButton = that.container.find("div[role=do_search]");
        that._searchLoader = that.container.find('div[role=search_loader]');
        that._searchResults = that.container.find("div[role=search_results]");
        that._searchResultsItems = that._searchResults.find("._search_result_item");
        that._searchTabs = that.container.find('[role="search_ext_tabs"]');

        that._loadingXhr = false;

        that._initHandlers();
    },

    onAdd: function(view){
        var that = this;
        that.view = view;

        that.searchObjectsUrl = view._project.options.apiUrl + view._project.options.mapCode + '/search/';

        that.searchAddressUrl = that.options.url;
        // Тестовая завязка на геосервис геопортала
        // that.searchAddressUrl = 'http://admin.geoportal40.ru/geosearch/search/';

        // Вкладка Объекты
        that._searchObjectsTab = that._searchTabs.find('[role="search_objects_tab"]');

        // Вкладка Адрес - типа есть всегда, но ищет или через наш геосервис, или через Яндекс
        that._searchAddressTab = that._searchTabs.find('[role="search_address_tab"]');
        // if (!that.options.geosearch) {
         //    that._searchAddressTab.remove();
        // }

        // Если выключен поиск по названиям слоёв или по метаданным - скрываем вкладку
        if (!that.searchSettings.searchLayersNames && !that.searchSettings.searchMeta){
            that._searchObjectsTab.remove();
            that._searchTabs.hide();
        }

        // if (that.options.hideTabSwitcher) {
         //    that._searchTabs.hide();
        // }

        // Первую вкладку делаем активной
        that._setActiveTab(that._searchTabs.find('li:first'));
    },

    _setActiveTab: function($tab, forceSearch){
        var that = this;

        var is_new_tab = $tab.is(':not(.active)');

        if (is_new_tab) {
            that._searchTabs.find('li.active').removeClass('active');
            $tab.addClass('active');

            that.activeTab = $tab.data('tab');
        }

        if (forceSearch) {
            that._searchInput.select();

            if (is_new_tab) {
                that._search();
            }
        }
    },

    _expand: function(select){
        var that = this;
        that.container.addClass("active");
        if (select)
            that._searchInput.select();
    },

    _initHandlers: function(){
        var that = this;
        var curElem, nextElem, prevElem;

        that._searchTabs.on('click', 'li:not(.active)', function(){
            that._setActiveTab($(this), true);
        });

        that._searchResults.on("click", "._search_result_item", function(){
            var $this = $(this);
            that.container.removeClass("active");

            //
            that.fire('searchResultItemClick');

            switch ($this.data('type')){
                case 'address':
                case 'addressYandex':
                    that._displayGeometry($this);
                    break;
                case 'layer':
                case 'object':
                    var id = $this.data('id');
                    if (!that.searchResults.hasOwnProperty(id))
                        return;

                    var obj = that.searchResults[id];
                    that.fire('searchItemClick', { object: obj });
                    break;
                case 'public-cadastre':
                    that.fire('cadastreSearchItemClick', {
                        id: $this.data('ccid'),
                        center: $this.data('center'),
                        extent: $this.data('extent')
                    });
                    break;
                default:
                    return;
            }
        });

        that._searchResults.on("mouseenter", "._search_result_item", function(){
            that._searchResultsItems.removeClass("active");
            $(this).addClass("active");
        });

        that._searchInput.on("keydown", function(event){
            if (event.keyCode == 13) {
                if (that._searchInput.val() != "" && (that.madeRequestWith == that._searchInput.val())) {
                    if (that._searchResults.find(".active").length) {
                        that._searchResults.find(".active").trigger("click");
                        that._searchInput.blur();
                    } else /* if (that.madeRequestWith != that._searchInput.val())*/ {
                        that._search();
                    }
                } else {
                    that._search();
                }
                // Т.к. используется form для бага хрома версии 66.0.3359.139, необходимо вернуть false, чтобы страница не перезагрузилась
                return false;
            } else if (event.keyCode == 38) {
                // up
                event.preventDefault();
                curElem = that._searchResults.find(".active");

                if (!curElem.length) {
                    curElem = that._searchResultsItems.first();
                }

                prevElem = curElem.prev();

                if (!prevElem.length) {
                    prevElem = that._searchResultsItems.last();
                }

                curElem.removeClass("active");
                prevElem.addClass("active");
            } else if (event.keyCode == 40) {
                // down
                event.preventDefault();
                curElem = that._searchResults.find(".active");

                if (!curElem.length) {
                    curElem = that._searchResultsItems.last();
                }

                nextElem = curElem.next();

                if (!nextElem.length) {
                    nextElem = that._searchResultsItems.first();
                }

                curElem.removeClass("active");
                nextElem.addClass("active");
            } else {
                setInterval(function(){
                    that._searchButton.toggleClass('clear_search', that._searchInput.val() != '');
                }, 0);
            }
        });

        that._searchInput.on("keyup", function(){
            if ($(this).val().length == 0) {
                //очищаем маркеры и результаты поиска
                that.layer.setSource();
                that._searchResults.empty();
                // that.container.removeClass("active");

                if (that.activeTab == 'objects'){
                    that._handleSearchDescription();
                }
            }
        });

        that._searchInput.focusin(function(){
            $(this).select();
            // that._searchResultsItems.addClass("active");
            that._searchInputWrapper.addClass("input-focused");

            if ($(this).val().length == 0) {
                if (that.activeTab == 'objects'){
                    that._handleSearchDescription();
                }
            }
        });

        that._searchInput.blur(function(){
            that._searchInputWrapper.removeClass("input-focused");
        });

        that._searchButton.on("click", function(){
            if($(this).hasClass('clear_search')){
                that._searchInput.val('').focus();
                that._search();

                //очищаем маркеры и результаты поиска
                that.layer.setSource();
                that._searchResults.empty();
                // that.container.removeClass("active");

                if (that.activeTab == 'objects'){
                    that._handleSearchDescription();
                }
            }
            else {
                if (that._searchInput.val() != "") {
                    that._search();
                    that._searchInput.focus();
                }
            }
        });

        that.container.on("click", function(e){
            if ($(e.target).hasClass("clearfix")) {
                that._searchInput.focus();
            }
        });

        that.container.focusin(function(){
            that._expand();
            // that.container.addClass("active");
            // if (that._searchInput.val() != "" && !that._searchResults.is(":empty")) {
            //     that.container.addClass("active");
            // }
        });

        that._searchInputWrapper.on('click', function(){
            that._searchInput.select();
        });

        that.container.focusout(function(){
            that._searchResultsItems.removeClass("active");
            that.container.removeClass("active");
        });

    },

    /**
     * Парсит переданную строку search_string и возвращает координаты в виде
     * массива или null
     * @param {string} search_string
     * @returns {[number, number]|null}
     */
    _parseCoordinates: function(search_string) {
        var reg = /^\s*(-?\d{1,3}[.,]\d+)\s*[,;]?\s*(-?\d{1,3}[.,]\d+)\s*$/;
        var parse_results = reg.exec(search_string);
        if (parse_results !== null) {
            var coord1 = parseFloat(parse_results[1].replace(',', '.'));
            var coord2 = parseFloat(parse_results[2].replace(',', '.'));

            if (!_.isNaN(coord1) && !_.isNaN(coord2)) {
                return [coord1, coord2];
            }
        } else {
            return null;
        }
    },

    _search: function(){
        var that = this,
            query = that._searchInput.val().trim(),
            position;

        that._searchCancelPrevious();
        that._searchResults.empty();

        if (query.length == 0) {
            if (that.activeTab == 'objects'){
                that._handleSearchDescription();
            }
            else {
                that._searchResults.empty();
            }
            return;
        }

        // Кадастровые номера не дадим проверять парсеру координат
        var cadastreRe = /^(\s)*(\d{2})(:\d{2})?(:\d{1,7})?(:\d{1,})?(\s)*$/;
        if (cadastreRe.test(query)){
            // Не будем проверять на координату
        }
        else {
            if (that.activeTab !== 'cadastre') {
                // Проверим, а не координата ли это
                try{
                    position = that._parseCoordinates(query);
                    if (position) {
                        that._displayEnteredPoint(
                            ol.proj.transform([position[1], position[0]], "EPSG:4326", "EPSG:3857")
                        );
                        return;
                    }
                } catch(error){
                }
            }
        }

        // Определим режим
        switch (that.activeTab){
            case 'objects':
                // Ищем объекты или слои, в зависимости от настроек
                that._searchObjects(query);
                break;
            case 'address':
                // Ищем через Яндекс
                if (that.searchSettings.searchYandexApi) {
                    that._searchAddressYandex(query);
                }
                // Ищем через наш геосервис
                else {
                    that._searchAddress(query);
                }
                break;
            case 'cadastre':
                that._searchCadastre(query);
                break;
            default:
                return;
        }
    },

    _searchObjects: function(query){
        var that = this,
            data = {
                'phrase': query,
                'limit': that.searchSettings.searchLimit ? parseInt(that.searchSettings.searchLimit) : 5
            };

        if (that.view._project.token){
            data['token'] = that.view._project.token;
        }
        if (that.view._project.lng){
            // для поискового запроса именно lang, а не lng
            data['lang'] = that.view._project.lng;
        }

        that._loadingXhr = $.ajax({
            url: that.searchObjectsUrl,
            method: 'GET',
            data: data,
            beforeSend: function(){
                that._searchBeforeSend();
            }
        }).done(function(response){
            that.searchResults = response;
            if (that.options.strictSearch) {
                that.searchResults = that.strictFilter(that.searchResults, query);
            }

            that._renderObjectsResults(that.searchResults, query);
        }).fail(function(response){
            // сервер упал
            that._handleServerInternalError();
            // that.container.addClass("active");
            that.madeRequestWith = false;
        }).always(function(){
            that._searchAfterSend();
        });
    },

    _searchAddress: function(query){
        var that = this;

        that._loadingXhr = $.ajax({
            url: that.searchAddressUrl,
            method: "GET",
            data: {
                query: query,
                returnGeom: 1,
                limit: that.searchSettings.searchLimit ? parseInt(that.searchSettings.searchLimit) : 5
            },
            beforeSend: function(){
                that._searchBeforeSend();
            }
        }).done(function(response){
            that.searchResults = response.results;
            that._renderAddressResults(that.searchResults);
        }).fail(function(response){
            switch (response.status) {
                case 404:
                    // сервер ничего не нашел
                    that._handleEmptyAnswer();
                    break;
                case 500:
                    // сервер упал
                    that._handleServerInternalError();
                    break;
            }
            that.madeRequestWith = false;
        }).always(function(){
            that._searchAfterSend();
        });
    },

    _searchAddressYandex: function(query) {
        var that = this;
        var ss = that.searchSettings;

        var yandex_limit = { bbox: "", rspn: 0 };

        if (
            ss.searchYandexLowerLeftCorner
            && ss.searchYandexUpperRightCorner
        ) {
            yandex_limit.bbox = ss.searchYandexLowerLeftCorner + "~" + ss.searchYandexUpperRightCorner;
            // yandex_limit.rspn = 1;
        } else {
            yandex_limit = {};
        }

        that._loadingXhr = $.ajax({
            type: 'GET',
            url: "https://geocode-maps.yandex.ru/1.x/",
            data: $.extend({}, {
                'geocode': query,
                'format': 'json',
                'results': that.searchSettings.searchLimit ? parseInt(that.searchSettings.searchLimit) : 5
            }, yandex_limit),
            beforeSend: function () {
                that._searchBeforeSend();
            }
        }).done(function (response) {
            that.searchResults = response['response']['GeoObjectCollection']['featureMember'];
            that._renderAddressYandexResults(that.searchResults);
        }).fail(function (response) {
            switch (response.status) {
                case 404:
                    // сервер ничего не нашел
                    that._handleEmptyAnswer();
                    break;
                case 500:
                    // сервер упал
                    that._handleServerInternalError();
                    break;
            }
            that.madeRequestWith = false;
        }).always(function () {
            that._searchAfterSend();
        });
    },

    _searchCadastre: function(query) {
        var that = this;

        query = query.replace(/:+$/gi, '');

        var layers = [
            {id: 1, title: 'Участок',   reg: /^\d\d:\d+:\d+:\d+$/},
            {id: 2, title: 'Квартал',   reg: /^\d\d:\d+:\d+$/},
            {id: 3, title: 'Район',     reg: /^\d\d:\d+$/},
            {id: 4, title: 'Округ',     reg: /^\d\d$/},
            {id: 5, title: 'ОКС',       reg: /^\d\d:\d+:\d+:\d+:\d+$/},
            // {id: 6, title: 'ОКС',       reg: /.*/},
        ];

        // var requests = [];
        for (var i = 0; i < layers.length; i++) {
            var layer = layers[i];
            if (query.search(layer.reg) !== -1) {
                that._loadingXhr = $.ajax({
                    method: 'GET',
                    url: 'https://pkk5.rosreestr.ru/api/features/'+
                            layer.id +'?text='+ query +'&limit=1'
                });
                break;
            }
        }

        // that._loadingXhr = [].concat(requests);

        if (that._loadingXhr) {
            that._loadingXhr.then(function(response){
                // var args = [].slice.call(arguments);

                // var features = [];
                // if (requests.length === 1) {
                    // var response = args[0];
                    // features = features.concat(response.features);
                // } else {
                    // for (var i = 0; i < args.length; i++) {
                        // var response = args[i];
                        // features = features.concat(response.features);
                    // }
                // }

                var $html = that._renderCadastreResults(response.features);
                that._searchResults.html($html);
            });
        } else {
            var $html = that._renderCadastreResults([]);
            that._searchResults.html($html);
        }
    },

    _renderCadastreResults: function(features) {
        var that = this;
        var $html = $("<ul role='results_container'></ul>");

        var $results = $(cadastre_search_item({
            features: features,
            empty_message: that.translate('По вашему запросу ничего не найдено')
        }));
        $html.html($results);

        return $html;
    },

    _searchBeforeSend: function(){
        var that = this;

        that._searchLoader.addClass('loading');
        that.madeRequestWith = that._searchInput.val();
        that.searchResults.length = 0;
    },

    _searchAfterSend: function(){
        var that = this;

        that._loadingXhr = false;
        that._searchLoader.removeClass("loading");
    },

    _searchCancelPrevious: function(){
        var that = this;

        if (that._loadingXhr){
            that._loadingXhr.abort();
            that._loadingXhr = false;
        }
    },

    returnPathFromApiUrl: function(url){
        return url.replace(/(\/\/[a-zA-Z.]*)/, "");
    },

    strictFilter: function(results, query) {
        var newRes;
        var queryArr = query.trim().split(' ');
        var currValue = '';
        var match;
        var i;

        newRes = results.filter(function(res){
            match = true;
            currValue = ' ' + res.value.trim().toLowerCase() + ' ';
            currValue = currValue.replace('(', ' ');
            for(i in queryArr) {
                match &= !!~currValue.indexOf(' ' + queryArr[i].toLowerCase() + ' ');
            }

            return match;
        });

        return newRes;
    },

    _renderObjectsResults: function(results, query){
        var that = this,
            $html,
            obj,
            fake_obj,
            icon;

        // if (that.options.strictSearch) {
         //    results = that.strictFilter(results, query);
        // }

        var baseUrl = that.view.getProject()._getApiLocation().host;

        if (results.length) {
            $html = $("<ul role='results_container'></ul>");
            for (var i = 0; i < results.length; i++) {
                obj = results[i];

                if ((this.options.showIcons == undefined) || this.options.showIcons) {
                    icon = '//' + baseUrl + obj['layer_icon'];
                } else {
                    icon = undefined;
                }

                switch(obj['type']){
                    case 'layer':
                        fake_obj = {
                            id: i,
                            type: obj['type'],
                            name: obj['name'] ? obj['name'] : obj['code'],
                            desc: that.translate('Слой карты'),
                            icon: '//' + baseUrl + obj['icon'],
                            hideParents: false
                        };
                        break;
                    case 'object':
                        fake_obj = {
                            id: i,
                            type: obj['type'],
                            name: obj['name'],
                            desc: obj['layer_name'] ? obj['layer_name'] : obj['layer'],
                            icon: icon,
                            hideParents: this.options.hideParents || false
                        };
                        break;
                    default:
                        continue;
                }
                $html.append($(search_item(fake_obj)))
            }

            that._updateResultsMaxHeight();

            that._searchResults.html($html);
            that._searchResultsItems = $html.find("li[role='search_result_item']");
        } else {
            that._handleEmptyAnswer();
        }

        that._expand();
    },

    _renderAddressResults: function(results){
        var that = this,
            $html,
            obj;

        if (results.length) {
            $html = $("<ul role='results_container'></ul>");
            for (var i = 0; i < results.length; i++) {
                obj = results[i];

                $html.append($(search_item({
                    id: i,
                    type: 'address',
                    name: (obj["name"]||obj["address"]||obj["id"]),
                    parents: obj.parents,
                    hideParents: false
                })))
            }

            that._updateResultsMaxHeight();

            that._searchResults.html($html);
            that._searchResultsItems = $html.find("li[role='search_result_item']");
        } else {
            that._handleEmptyAnswer();
        }

        that._expand();
    },

    _renderAddressYandexResults: function(results){
        var that = this,
            $html,
            obj;

        if (results.length) {
            $html = $("<ul role='results_container'></ul>");
            for (var i = 0; i < results.length; i++) {
                obj = results[i]['GeoObject'];

                $html.append($(search_item({
                    id: i,
                    type: 'addressYandex',
                    name: obj["name"],
                    desc: obj["description"],
                    hideParents: false
                })))
            }

            that._updateResultsMaxHeight();

            that._searchResults.html($html);
            that._searchResultsItems = $html.find("li[role='search_result_item']");
        } else {
            that._handleEmptyAnswer();
        }

        that._expand();
    },

    _updateResultsMaxHeight: function() {
        var that = this;
        that._searchResults.css('max-height', $(window).height() - that._searchResults.offset().top);
    },

    _handleEmptyAnswer: function () {
        var that = this;
        that._searchResults.html($("<div class='info-results'>"
            + that.translate('По вашему запросу ничего не найдено')
            + "</div>"));
        // that._expand(true);
    },

    _handleServerInternalError: function(){
        var that = this;
        that._searchResults.html($("<div class='info-results'>"
            + that.translate('Произошла ошибка на стороне сервера')
            + "</div>"));
        // that._expand(true);
    },

    _handleSearchDescription: function(){
        var that = this;
        if (that.searchSettings.description && that.searchSettings.description != '') {
            that._searchResults.html($("<div class='info-results'></div>").text(that.searchSettings.description));
            // that._expand(true);
        }
    },

    _displayEnteredPoint: function(point){
        var that = this,
            geom,
            feature;

        geom = new ol.geom.Point(point);

        feature = new ol.Feature({
            geometry: geom
        });

        that.map.getView().fit(geom, {
            maxZoom: 15
        });

        feature.setStyle(new ol.style.Style({
            image: that.marker
        }));

        that.layer.setSource();
        that.layer.setSource( new ol.source.Vector({features: [feature]}) );
    },

    _displayGeometry: function($elem){
        var that = this,
            elemID = $elem.data('id'),
            obj, point, geom, feature;

        if (!that.searchResults[elemID])
            return;

        switch ($elem.data('type')){
            case 'address':
                obj = that.searchResults[elemID];
                point = obj.geom;

                // geomType = that.searchResults[elemID].bbox.type;
                geom = new ol.geom.Point(
                    ol.proj.transform(point, "EPSG:4326", "EPSG:3857")
                );

                that.map.getView().fit(geom, {
                    maxZoom: obj.zoom || 10
                });

                break;
            case 'addressYandex':
                obj = that.searchResults[elemID]['GeoObject'];

                var pos = obj['Point']['pos'].split(' ');
                pos = ol.proj.transform([+pos[0], +pos[1]], 'EPSG:4326', 'EPSG:3857');

                var lower = obj['boundedBy']['Envelope']['lowerCorner'].split(' ');
                lower = ol.proj.transform([+lower[0], +lower[1]], 'EPSG:4326', 'EPSG:3857');

                var upper = obj['boundedBy']['Envelope']['upperCorner'].split(' ');
                upper = ol.proj.transform([+upper[0], +upper[1]], 'EPSG:4326', 'EPSG:3857');

                var extent = lower.concat(upper);

                var view = that.map.getView();
                view.setCenter(pos);
                view.fit(extent);

                geom = new ol.geom.Point(pos);
                break;
            default:
                return;
        }

        feature = new ol.Feature({
            geometry: geom
        });

        feature.setStyle(new ol.style.Style({
            image: that.marker
        }));

        that.layer.setSource();
        that.layer.setSource( new ol.source.Vector({features: [feature]}) );
    },

    _geojsonToFeature: function(geojson){
        var formatGeoJSON = new omjs.ol.format.GeoJSON();

        return  formatGeoJSON.readFeatures(geojson, {
            dataProjection: new omjs.ol.proj.Projection({code: "EPSG:3857"})
        });
    },

    _makeGeoJSONFromGeom: function(geom){
        var geoJSON = {};
        var geomCoordinates;
        var geomType = (geom.type.indexOf("Multi")!= -1)?
            geom.type.substring(5, geom.type.length):geom.type;

        geomCoordinates = omjs.ol.proj.transform(geom.coordinates, "EPSG:4326", "EPSG:3857");

        if (geomCoordinates.length > 1 && geom.type.indexOf("Multi")!= -1) {
            geoJSON =  {
                "type": "FeatureCollection",
                "features": []
            };

            for (var i = 0; i<geomCoordinates.length; i++) {
                geoJSON.features.push({
                    "type": "Feature",
                    "geometry": {
                        "type": geomType,
                        "coordinates": geomCoordinates[i]
                    },
                    "properties": null
                })
            }

        } else {
            geoJSON = {
                "type": "Feature",
                "geometry": {
                    type: geom.type,
                    coordinates: geomCoordinates
                },
                "properties": {}
            };
        }

        return geoJSON;
    }

});

module.exports = SearchBarExt;



//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/SearchBarExt/SearchBarExt.js
// module id = 251
// module chunks = 0